import { graphql } from '@/client/services/api/graphql/gql';

export const archiveUserAIConversationMutation = graphql(`
  mutation ArchiveUserAIConversation($conversationId: String!) {
    archiveConversation(id: $conversationId)
  }
`);
